var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "holder" }, [
    _c(
      "h2",
      { attrs: { id: "page-header" } },
      [
        _c("router-link", { attrs: { to: "/" } }, [
          _vm._v("My Arlington - Projects")
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "layer-page" }, [
      _c("div", { staticClass: "widget" }, [
        _vm.project
          ? _c("div", [
              _c("h3", [
                _vm._v("Building permits for " + _vm._s(_vm.project.title))
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("table", [
                _c("caption", { staticClass: "table-caption" }, [
                  _vm._v("Permits for " + _vm._s(_vm.project.title))
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.permits, function(permit) {
                    return _c("tr", { key: permit.permitKey }, [
                      _c("td", [
                        _c(
                          "a",
                          {
                            attrs: {
                              target: "_blank",
                              rel: "noopener noreferrer",
                              href:
                                "https://permits.arlingtonva.us/Permit_Status.aspx?p_number=" +
                                permit.permitNbr
                            }
                          },
                          [_vm._v(_vm._s(permit.permitNbr))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(permit.streetAddressText))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(permit.permitTypeCode))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(permit.permitStatusCode))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(permit.permitHolderName))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(permit.propertyOwnerName))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm._f("defaultDate")(permit.appliedDate))
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm._f("defaultDate")(permit.approveDate))
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm._f("defaultDate")(permit.issuedDate)))
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(permit.permitDescriptionText))])
                    ])
                  }),
                  0
                )
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Permit #")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Address")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Type")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Permit holder")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Owner")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Applied date")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Approved date")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Date issued")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Description")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-19bf2b7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19bf2b7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/Project.vue
// module id = ueyp
// module chunks = 1